import type { DatasetSummary, ProfileDatasetSection } from '../../types/datasetTypes';

export const isListSourceDataset = (dataset: DatasetSummary): boolean => (
  dataset.kind === 'list'
);

export const getListDatasetsInWorkspace = (
  sections: ProfileDatasetSection[],
  rootFolderId: string,
): DatasetSummary[] => (
  sections
    .filter((section) => section.rootFolderId === rootFolderId)
    .flatMap((section) => section.datasets)
    .filter(isListSourceDataset)
);
